export default __webpack_public_path__ + "static/media/mapMarker.eed24750.svg";